import { ModuleWithProviders, NgModule } from '@angular/core';
import { SERVICE_PROVIDERS } from '@config/service-providers.config';
import { environment } from '@environments/environment';

export namespace Utils {
  export function resolveServiceProvidersConfig(serviceProviders) {
    const serviceProviderResolvers = [];

    for (const provide in serviceProviders) {
      if (!serviceProviders.hasOwnProperty(provide)) {
        continue;
      }

      const env = environment.envName === 'local' ? 'local' : 'default';
      const useClass = serviceProviders[provide][env];

      serviceProviderResolvers.push({ provide, useClass });
    }
    return serviceProviderResolvers;
  }
}

@NgModule()
export class UtilsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: UtilsModule,
      providers: Utils.resolveServiceProvidersConfig(SERVICE_PROVIDERS)
    };
  }
}
